import { useCallback, useState } from 'react';

// Sincroniza uma lista de produtos em lote, um por vez (mesmo comportamento
// sequencial das telas antigas), reportando progresso conforme cada produto
// termina.
export function useBulkSync(products, syncFn) {
  const [syncing, setSyncing] = useState(false);
  const [syncedCount, setSyncedCount] = useState(0);
  const [failedCount, setFailedCount] = useState(0);

  const total = products.length;
  const percent = total > 0 ? Math.min(100, (syncedCount / total) * 100) : 0;

  const runBulkSync = useCallback(async () => {
    setSyncing(true);
    setSyncedCount(0);
    setFailedCount(0);

    let done = 0;
    let failed = 0;
    for (const product of products) {
      if (!product) continue;
      try {
        await syncFn(product);
      } catch (err) {
        failed += 1;
        setFailedCount(failed);
      }
      done += 1;
      setSyncedCount(done);
    }

    setSyncing(false);
  }, [products, syncFn]);

  return { syncing, syncedCount, failedCount, percent, runBulkSync };
}
